import {ErrorHandler, Injectable} from '@angular/core';
import {ErrorReporter} from '../../shared/error-reporting/error-reporter';

/** Angular ErrorHandler that forwards scrubbed events to ErrorReporter (AC-18). */
@Injectable()
export class ErrorsHandler implements ErrorHandler {

  constructor(private reporter: ErrorReporter) {}

  handleError(error: Error): void {
    try {
      this.reporter.report(error);
    } catch {
      // Never throw from ErrorHandler
    }
    // Preserve local visibility during development / when reporter is console-only.
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
